import React from 'react';
import { DesignSystemProviderWithLocale } from '../DesignSystemProviderWithLocale';

import { TopBar } from '../TopBar/TopBar';
import { Navigation } from '../Navigation/Navigation';
import { InfoContext } from '../../context';
import { NormalizeStyles } from '../../components/NormalizeStyles/NormalizeStyles';
import { useHeaderHeightCSSProperty } from '../../helpers/useHeaderHeightCSSProperty';
import { Loading } from '../../components/Loading/Loading';
import { Localization } from '../Localization/Localization';
import useInitHeader from '../../helpers/useInitHeader';
import { DateFnsLocaleProvider } from '../Localization/DateFnsLocaleProvider';
import '../../css/unified-header.css';
import '../../css/daterangepicker-bs3.css';
import '../../css/header-admin.css';

export function Main() {
	useHeaderHeightCSSProperty();

	const { isLoading, headerInfo } = useInitHeader();
	const showLoader = isLoading;

	return showLoader ? (
		<Loading />
	) : (
		<InfoContext.Provider value={headerInfo}>
			<DateFnsLocaleProvider>
				<NormalizeStyles />
				<DesignSystemProviderWithLocale>
					<Localization>
						<TopBar />
						<Navigation />
					</Localization>
				</DesignSystemProviderWithLocale>
			</DateFnsLocaleProvider>
		</InfoContext.Provider>
	);
}
